import { createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { CommonInventoryType } from '@dynamika-shared/types/inventory';
import {
  InvitationsUserManagementState,
  Invitation,
  CreateInvitationRequest,
  ApiError,
} from './invitationsUserManagement.types';
import { createSelector, createSliceHook, makeActionCreator } from '../helpers';

const initialState: InvitationsUserManagementState = {
  loading: false,
  actionLoading: false,
  sponsorsLoading: false,
  error: undefined,
  data: [],
  sponsors: [],
};

const { actResolve, actReject, actReq } =
  makeActionCreator<InvitationsUserManagementState>();

export const invitationsUserManagementSlice = createSlice({
  name: 'invitationsUserManagement',
  initialState,
  reducers: {
    fetchInvitationsList: actReq<{ sponsorId: string }>(),
    fetchInvitationsListSuccess: actResolve<Invitation[]>(),
    fetchInvitationsListFailure: actReject<AxiosError<ApiError>>(),

    fetchInvitationSponsors: actReq('sponsorsLoading'),
    fetchInvitationSponsorsSuccess: actResolve<CommonInventoryType[]>(
      'sponsors',
      'sponsorsLoading'
    ),
    fetchInvitationSponsorsFailure: actReject<AxiosError<ApiError>>(
      'error',
      'sponsorsLoading'
    ),

    createInvitation: actReq<CreateInvitationRequest>('actionLoading'),
    createInvitationSuccess: actResolve<undefined>(null, 'actionLoading'),
    createInvitationFailure: actReject<AxiosError<ApiError>>(
      'error',
      'actionLoading'
    ),

    revokeInvitation: actReq<string>('actionLoading'),
    revokeInvitationSuccess: actResolve<undefined>(null, 'actionLoading'),
    revokeInvitationFailure: actReject<AxiosError<ApiError>>(
      'error',
      'actionLoading'
    ),
  },
});

export const {
  fetchInvitationsList,
  fetchInvitationsListSuccess,
  fetchInvitationsListFailure,
  fetchInvitationSponsors,
  fetchInvitationSponsorsSuccess,
  fetchInvitationSponsorsFailure,
  createInvitation,
  createInvitationSuccess,
  createInvitationFailure,
  revokeInvitation,
  revokeInvitationSuccess,
  revokeInvitationFailure,
} = invitationsUserManagementSlice.actions;

export const actions = {
  ...invitationsUserManagementSlice.actions,
};

export const useInvitationsUserManagementSlice = createSliceHook(
  invitationsUserManagementSlice.name,
  actions
);

export const selectInvitationsUserManagementState = createSelector(
  'invitationsUserManagement'
);
